
import { Component, Prop, Vue } from "nuxt-property-decorator";

@Component
export default class PelletsComparisonBarWrapper extends Vue {
  @Prop({ required: true }) visible!: boolean;
}
